var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import moment from "moment";
import withBranding from "@irati/brand/withBranding";
import { determineDealThumbnailImage } from "@irati/deals/helpers/deals/appearance";
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import dealRedemptionService from "@irati/deals/services/dealRedemption";
import notify from "@irati/utils/notify/index";
import { Body, Label, H5 } from "@irati/ui/src/Typography";
import { hasRedemptionExpired as hasRedemptionExpiredHelper } from "@irati/deals/helpers/deals/isTimeLimited";
import ViewPerkOnAppOnly from "../../MyPerks/ViewPerkOnAppOnly";
import { DealAvatar, ItemContainer, LogoWrapper, MobileQty, StyledButton, StyledHr, StyledRow, StyledDeleteHeaderCol, StyledDeleteButtonCol } from "../styled/MyPerksItem";
import TimeLimitedDeal from "./TimeLimitedDeal";
var MyPerkItem = /** @class */ (function (_super) {
    __extends(MyPerkItem, _super);
    function MyPerkItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleArchiveRedemption = function () {
            var _a = _this.props, redemption = _a.redemption, onArchiveSuccess = _a.onArchiveSuccess, formatMessage = _a.formatMessage;
            var uuid = redemption.uuid, Etag = redemption.Etag;
            return dealRedemptionService
                .archive(uuid, Etag)
                .then(function () {
                if (onArchiveSuccess)
                    onArchiveSuccess(redemption);
            })
                .catch(function (error) {
                notify.error({
                    message: formatMessage({ id: error.message }),
                    position: "top-right"
                });
            });
        };
        return _this;
    }
    MyPerkItem.prototype.render = function () {
        var _a = this.props, redemption = _a.redemption, onViewRedemption = _a.onViewRedemption, onMarkAsUsed = _a.onMarkAsUsed, usedPerksOptionActive = _a.usedPerksOptionActive, formatMessage = _a.formatMessage, branding = _a.branding;
        var orderProducts = get(redemption, "order.products", []);
        var quantity = orderProducts.reduce(function (acc, product) { return acc + product.items.length; }, 0);
        var thumbnailImage = determineDealThumbnailImage(get(redemption, "deal"), branding);
        var perkIsAppOnly = isAppOnly(get(redemption, "deal"));
        var perkIsUnavailable = get(redemption, "dealUnavailable");
        var hasRedemptionExpired = hasRedemptionExpiredHelper(redemption);
        var ViewPerkComponent = (React.createElement(StyledButton, { primary: true, full: true, onClick: function () { return onViewRedemption(redemption.uuid); }, small: true, disabled: hasRedemptionExpired },
            React.createElement(FormattedMessage, { id: "perks.components.myPerks.myPerksItem.view" })));
        if (perkIsAppOnly) {
            ViewPerkComponent = React.createElement(ViewPerkOnAppOnly, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledHr, null),
            React.createElement(ItemContainer, { addGreyBackground: perkIsUnavailable },
                React.createElement(StyledRow, { key: redemption.uuid },
                    React.createElement(Col, { sm: 2 },
                        React.createElement(LogoWrapper, null,
                            React.createElement(DealAvatar, { src: thumbnailImage, alt: get(redemption, "deal.header", "placeholder image"), extraSmall: true, withShadow: true }))),
                    React.createElement(Col, { xs: 4, sm: 7 },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, sm: 6, md: 7 },
                                React.createElement(H5, { overflowWrap: "break-word" }, get(redemption, "deal.header", formatMessage({ id: "perks.myPerks.dealHeader.placeholder" }))),
                                quantity > 0 && (React.createElement(MobileQty, { small: true },
                                    React.createElement(FormattedMessage, { id: "perks.components.myPerks.myPerksItem.quantity", values: { quantity: quantity } })))),
                            React.createElement(Col, { xsHidden: true, sm: 3, md: 2 },
                                React.createElement(Body, { small: true }, !isEmpty(orderProducts) && quantity > 0 && "x " + quantity)),
                            React.createElement(Col, { xsHidden: true, sm: 3, md: 3 },
                                React.createElement(Body, { small: true }, moment.unix(redemption.dateUnix).format("DD/MM/YY"))))),
                    !perkIsUnavailable && (React.createElement(Col, { xs: 5, sm: 3 },
                        ViewPerkComponent,
                        React.createElement(StyledButton, { onClick: onMarkAsUsed, small: true, full: true },
                            React.createElement(FormattedMessage, { id: usedPerksOptionActive ? "perks.myPerks.myPerksItem.moveBack" : "perks.myPerks.myPerksItem.markAsUsed" }))))),
                hasRedemptionExpired && React.createElement(TimeLimitedDeal, { deal: redemption.deal }),
                perkIsUnavailable && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(StyledHr, null)),
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Row, null,
                            React.createElement(StyledDeleteHeaderCol, { xs: 8, sm: 9 },
                                React.createElement(Label, { large: true, display: "inline-block", marginBottom: 1 },
                                    React.createElement(FormattedMessage, { id: "perks.myPerks.myPerksItem.perkNotAvailable.header" })),
                                React.createElement(Body, { small: true },
                                    React.createElement(FormattedMessage, { id: "perks.myPerks.myPerksItem.perkNotAvailable.para" }))),
                            React.createElement(StyledDeleteButtonCol, { xs: 4, sm: 3 },
                                React.createElement(StyledButton, { small: true, onClick: this.handleArchiveRedemption },
                                    React.createElement(FormattedMessage, { id: "perks.myPerks.myPerksItem.perkNotAvailable.delete" }))))))))));
    };
    return MyPerkItem;
}(PureComponent));
export default injectIntl(withBranding(MyPerkItem));
